import { useCallback, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTenantUsers } from "../../../../hooks/useTenantUsers";
import { selectSelectedTenantId } from "../../../../store/user/selectors";
import { updateConversation } from "../../../../store/chats/thunks";
import Modal from "../../../../components/generic/Modal";
import UserSelect from "../../../../components/shared/UserSelect";

const AddMembers = (props) => {
  const {
    onCancel,
    selectedChat: { members, id: conversation_id },
  } = props;
  const [submitting, setSubmitting] = useState(false);
  const [selectedUserIds, setSelectedUserIds] = useState([]);
  const { users } = useTenantUsers({ fetchUsers: false });
  const tenant_id = useSelector(selectSelectedTenantId);
  const dispatch = useDispatch();

  const usersWithDisabled = useMemo(() => {
    const memberIds = new Set(members.map((m) => m.id));

    return (
      users?.map((user) => ({
        ...user,
        disabled: memberIds.has(user.id),
      })) || []
    );
  }, [users, members]);

  const handleSubmit = useCallback(async () => {
    try {
      setSubmitting(true);

      await dispatch(
        updateConversation({
          payload: {
            conversation_id,
            add: selectedUserIds,
            tenant_id,
          },
          addedUsers: selectedUserIds.map((id) =>
            users?.find((u) => id === u?.id)
          ),
        })
      );
      onCancel();
    } catch (error) {
      console.log("🚀 ~ AddMembers.jsx:30 ~ AddMembers ~ error:", error);
    } finally {
      setSubmitting(false);
    }
  }, [selectedUserIds, conversation_id, tenant_id]);
  return (
    <Modal
      title={`Add members in to selected conversion`}
      onCancel={onCancel}
      width={480}
      open
      onOk={handleSubmit}
      isProcessing={submitting}
      okButtonProps={{
        loading: submitting,
        disabled: submitting || !selectedUserIds.length,
      }}
    >
      <div style={{ marginTop: "20px" }}>
        <UserSelect
          users={usersWithDisabled}
          value={selectedUserIds}
          onChange={setSelectedUserIds}
          listTitle={"Selected Members"}
        />
      </div>
    </Modal>
  );
};
export default AddMembers;
